import { createI18n } from 'vue-i18n';
import messages from 'src/i18n';

export function initI18n(app: any): void {
  // Create I18n instance
  const i18n = createI18n({
    locale: 'en',
    legacy: false,
    globalInjection: true,
    messages,
  });

  // Tell app to use the I18n instance
  app.use(i18n);
}
